import {Component, HostListener, OnInit} from '@angular/core';
import {AccountService} from '../../../services/account.service';
import {ActivatedRoute} from '@angular/router';
import {StatementService} from '../../../services/statement.service';
import {AccountDTO} from '../../../model/accountDTO';
import {PageStatementDTO} from '../../../model/pageStatementDTO';
import {SpringPageable} from '../../../services/spring-pageable';
import {StatementDTO} from '../../../model/statementDTO';
import {TransactionDTO} from '../../../model/transactionDTO';
import * as moment from 'moment/moment';
import {CurrencyService} from '../../../services/currency-service';

@Component({
  templateUrl: './account-debugging.component.html',
  styleUrls: ['./account-debugging.component.scss']
})
export class AccountDebuggingComponent implements OnInit {

  pageable: SpringPageable;
  page: PageStatementDTO;
  account: AccountDTO;
  dateSearch: string;

  constructor(private service: AccountService,
              private activatedRoute: ActivatedRoute,
              private currencyService: CurrencyService,
              private statementService: StatementService) {
  }

  ngOnInit(): void {
    this.pageable = this.createPageable();
    this.activatedRoute.params.subscribe(params =>
      this.service.get(params.accountId).subscribe(account => {
        this.account = account;
        this.updatePage();
      })
    );
  }

  updatePage() {
    this.statementService.get(this.account.id, this.pageable).subscribe(page => this.page = page);
  }

  private createPageable() {
    const pageable = new SpringPageable();
    pageable.setSort({column: 'openingBalanceDate', direction: 'asc'});
    pageable.size = 10;
    return pageable;
  }

  prev() {
    if (this.pageable.page === 0) return;
    this.pageable.page--;
    this.updatePage();
  }

  next() {
    if (this.pageable.page === this.page.totalPages - 1) return;
    this.pageable.page++;
    this.updatePage();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.code === 'ArrowLeft')
      this.prev();
    if (event.code === 'ArrowRight')
      this.next();
  }

  isDisconnected(prev: StatementDTO, next: StatementDTO) {
    return prev.calculatedClosingBalance !== next.calculatedOpeningBalance;
  }

  mismatchedFMinusC(statement: StatementDTO): boolean {
    if (statement.transactions == null)
      return false;
    const f = statement.calculatedClosingBalance - statement.calculatedOpeningBalance;
    const c = this.sum(statement.transactions);
    return this.roundNum(c) !== this.roundNum(f);
  }

  sum(transactions: Array<TransactionDTO>) {
    return transactions.reduce((acc, t) => acc + t.calculatedAmount, 0);
  }

  roundNum(num: number): number {
    const multiplier = Math.pow(10, 2);
    return Math.round(num * multiplier) / multiplier;
  }

  getPages(): number[] {
    return Array.from({ length: this.page.totalPages }, (_, i) => i);
  }

  dateSearchChange() {
    const date = moment(this.dateSearch, 'YYYY-MM-DD', true);
    if (date.isValid()) {
      this.statementService.getPageNumberByDate(this.account.id, this.dateSearch, this.pageable.size).subscribe(pageNumber => {
        this.pageable.page = pageNumber;
        this.updatePage();
      });
    }
  }

  euro(saldo: number) {
    return this.currencyService.euro(saldo);
  }

  iso(date: string) {
    return moment(date, 'DD-MM-YYYY', true).format('YYYY-MM-DD').toString();
  }
}
